import { useColorModeValue } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetEventEngagement } from '../../../../../services/online/calendar/calendar';
export const useLogic = (eventId) => {
    const [selectedFilter, setSelectedFilter] = useState('ALL');
    const { t } = useTranslation();
    const bg = useColorModeValue('gray.50', 'gray.800');
    const cardBg = useColorModeValue('white', 'gray.700');
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const { isLoading: isEventEngagementLooading, data: members } = useGetEventEngagement(eventId);
    const calculateCompletion = (members) => {
        if (!members?.length)
            return 0;
        let total = 0;
        let completed = 0;
        members.forEach(member => {
            if (member?.hasRSVP && member?.tasks?.length) {
                member.tasks.forEach(task => {
                    total++;
                    if (task?.completedOn)
                        completed++;
                });
            }
        });
        if (total === 0)
            return 0;
        return Math.round((completed / total) * 100) || 0;
    };
    const getMemberStatus = (member) => {
        if (!member?.hasRSVP) {
            return 'not_rsvp';
        }
        const totalTasks = member.tasks.length;
        if (totalTasks === 0) {
            return 0;
        }
        const completedTasks = member.tasks.filter(task => !!task.completedOn).length;
        return Math.round((completedTasks / totalTasks) * 100);
    };
    const sortMembers = (members) => {
        if (!members || members.length === 0)
            return [];
        return [...members].sort((a, b) => {
            if (!a.hasRSVP)
                return 1;
            if (!b.hasRSVP)
                return -1;
            const aCompleted = a.tasks.filter(t => t.completedOn).length / a.tasks.length;
            const bCompleted = b.tasks.filter(t => t.completedOn).length / b.tasks.length;
            return bCompleted - aCompleted;
        });
    };
    return {
        isEventEngagementLooading,
        selectedFilter,
        setSelectedFilter,
        bg,
        cardBg,
        borderColor,
        calculateCompletion,
        getMemberStatus,
        sortMembers,
        members,
    };
};
